<template>
	<div class="w-100 py-3">
		<div class="row slim-grid-row">
			<div class="col-4">
				<div class="w-100" :style="{'height': product.is_variant ? '45px' : '90px'}">
					<img :src="data.image_url" class="img-fit radius-6" />
				</div>
			</div>
			<div class="col-8">
				<div class="mb-0 body-1-2">{{data.name}}</div>
				<div v-if="!product.is_variant" class="w-100">
					<div class="w-100 mb-2"> 
						<p 
							v-if="is_decrease_promo" 
							class="mb-0 text-line-through body-3 d-inline-block align-middle mr-1">
							{{$formatCurrency(promotion_price)}}
						</p>
						<p 
							class="mb-0 body-2-4 text-orange d-inline-block align-middle"
							:class="{
								'd-inline-block align-middle': is_decrease_promo
							}"
							>
							{{$formatCurrency(final_price)}}
						</p>
					</div>
					<div class="w-50 ml-auto">
						<div class="row no-gutters">
							<div class="col-4 align-self-center text-left">
								<div @click="changeQtyProduct('minus')" class="ml-2 cursor-pointer">
									<svg width="26" height="26" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path class="fill-primary" d="M19.8333 14.6667C19.8333 14.9429 19.6095 15.1667 19.3333 15.1667H8.66666C8.39051 15.1667 8.16666 14.9428 8.16666 14.6667V13.3334C8.16666 13.0572 8.39051 12.8334 8.66666 12.8334H19.3333C19.6095 12.8334 19.8333 13.0572 19.8333 13.3334V14.6667Z" fill="#26B11D"/>
										<rect x="0.5" y="0.5" class="stroke-primary" width="27" height="27" rx="13.5" stroke="#26B11D"/>
									</svg>
									<!-- <img src="../../../assets/img/icon/svg-dec.svg" height="28"> -->
								</div>
							</div>
							<div class="col-4 align-self-center text-center">
								<p class="ml-2 pl-1 mb-0 sub-heading-1-2 text-center">{{qty_cart}}</p>
							</div>
							<div class="col-4 align-self-center text-right">
								<div @click="changeQtyProduct('plus')" class="cursor-pointer">
									<svg width="26" height="26" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path class="fill-primary" d="M21 14.5C21 14.7761 20.7761 15 20.5 15H15.5C15.2239 15 15 15.2239 15 15.5V20.5C15 20.7761 14.7761 21 14.5 21H13.5C13.2239 21 13 20.7761 13 20.5V15.5C13 15.2239 12.7761 15 12.5 15H7.5C7.22386 15 7 14.7761 7 14.5V13.5C7 13.2239 7.22386 13 7.5 13H12.5C12.7761 13 13 12.7761 13 12.5V7.5C13 7.22386 13.2239 7 13.5 7H14.5C14.7761 7 15 7.22386 15 7.5V12.5C15 12.7761 15.2239 13 15.5 13H20.5C20.7761 13 21 13.2239 21 13.5V14.5Z" fill="#26B11D"/>
										<rect x="0.5" y="0.5" class="stroke-primary" width="27" height="27" rx="13.5" stroke="#26B11D"/>
									</svg>
									<!-- <img src="../../../assets/img/icon/svg-inc.svg" height="28"> -->
								</div>
							</div>
						</div>
					</div>
				</div>
				<p v-else class="mb-0 body-2-2-1">{{product.variant_list.length}} Variants</p>
			</div>
			<div class="col-12 mt-3" v-if="product.is_variant">
				<div class="w-100">
					<div class="row slim-grid-row" v-for="(variant,index) in product.variant_list">
						<div class="col-8 align-self-center">
							<p class="mb-0 body-2-1">{{variant.data.name}}</p>
							<div class="no-ws w-100">
								<p 
									v-if="calcIsDecreasePromo(variant.data.price)" 
									class="mb-0 text-line-through body-3 d-inline-block align-middle mr-1">
									{{$formatCurrency(calPromotionPrice(variant.data.price))}}
								</p>
								<p 
									class="mb-0 body-2-4 text-orange"
									:class="{
										'd-inline-block align-middle': calcIsDecreasePromo(variant.data.price)
									}"
									>
									{{$formatCurrency($calculateFinalPriceConcierge(variant.data.price))}}
								</p>
							</div>
						</div>
						<div class="col-4 align-self-center">
							<div class="row no-gutters">
								<div class="col-4 align-self-center text-left">
									<div @click="changeQtyProduct('minus',variant)" class="cursor-pointer">
										<svg width="26" height="26" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path class="fill-primary" d="M19.8333 14.6667C19.8333 14.9429 19.6095 15.1667 19.3333 15.1667H8.66666C8.39051 15.1667 8.16666 14.9428 8.16666 14.6667V13.3334C8.16666 13.0572 8.39051 12.8334 8.66666 12.8334H19.3333C19.6095 12.8334 19.8333 13.0572 19.8333 13.3334V14.6667Z" fill="#26B11D"/>
											<rect x="0.5" y="0.5" class="stroke-primary" width="27" height="27" rx="13.5" stroke="#26B11D"/>
										</svg>
										<!-- <img src="../../../assets/img/icon/svg-dec.svg" height="28"> -->
									</div>
								</div>
								<div class="col-4 align-self-center text-center">
									<p class="ml-2 mb-0 sub-heading-1-2 text-center">{{variant.qty}}</p>
								</div>
								<div class="col-4 align-self-center text-right">
									<div @click="changeQtyProduct('plus',variant)" class="cursor-pointer">
										<svg width="26" height="26" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path class="fill-primary" d="M21 14.5C21 14.7761 20.7761 15 20.5 15H15.5C15.2239 15 15 15.2239 15 15.5V20.5C15 20.7761 14.7761 21 14.5 21H13.5C13.2239 21 13 20.7761 13 20.5V15.5C13 15.2239 12.7761 15 12.5 15H7.5C7.22386 15 7 14.7761 7 14.5V13.5C7 13.2239 7.22386 13 7.5 13H12.5C12.7761 13 13 12.7761 13 12.5V7.5C13 7.22386 13.2239 7 13.5 7H14.5C14.7761 7 15 7.22386 15 7.5V12.5C15 12.7761 15.2239 13 15.5 13H20.5C20.7761 13 21 13.2239 21 13.5V14.5Z" fill="#26B11D"/>
											<rect x="0.5" y="0.5" class="stroke-primary" width="27" height="27" rx="13.5" stroke="#26B11D"/>
										</svg>
										<!-- <img src="../../../assets/img/icon/svg-inc.svg" height="28"> -->
									</div>
								</div>
							</div>
						</div>
						<div v-if="index+1 < product.variant_list.length" class="col-12">
							<div class="my-3 w-100 border-b-semi-grey-dashed">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {mapMutations} from 'vuex'

	export default{
		props: ['product'],
		computed:{
			data(){
				return this.product.data
			},
			base_price(){
				return this.product.data.price
			},
			final_price(){
        return this.$calculateFinalPriceConcierge(this.base_price)
      },
      promotion_price(){
        return this.calPromotionPrice(this.base_price)
      },
      is_decrease_promo(){
        return this.calcIsDecreasePromo(this.base_price)
      },
      qty_cart(){
      	return this.product.qty
      }
		},
		methods:{
			...mapMutations(['setVoucherOrder','removeVoucherOrder']),
			changeQtyProduct(type,variant=null){
				let params = {
            product: this.data,
            variant: variant != null ? variant.data : {},
            qty: variant != null ? variant.qty : this.qty_cart
          }
          let other = {
          	min_buy_qty: variant != null ? variant.data.min_buy_qty : this.data.min_buy_qty,
          	max_buy_qty: variant != null ? variant.data.max_buy_qty : this.data.max_buy_qty,
          	availability: variant != null ? variant.data.availability : this.data.availability
          }
          if(params.qty == 1 && type == 'minus'){
            this.removeVoucherOrder(params)
          }else{
            if(this.data.category.code == 'experience'){
          		if(type == 'minus'){
          			if(other.min_buy_qty > 1 && params.qty == other.min_buy_qty){
	            		params.qty -= other.min_buy_qty
	            	}else{
	            		params.qty--
	            	}
	            }else{
	            	if(other.availability > params.qty && 
	            			(other.max_buy_qty == null || 
	            					(other.max_buy_qty != null && 
	            						params.qty < other.max_buy_qty)
	            					)
	            			)
	            		{
		            	if(other.min_buy_qty > 1 && params.qty == 0){
		            		params.qty += other.min_buy_qty
		            	}else{
		            		params.qty++	
		            	}
	            	}
	            }	
          	}else{
          		if(type == 'minus'){
	              params.qty--
	            }else{
	            	if(other.availability > params.qty){
	            		params.qty++
	            	}
	            }	
          	}
          	if(params.qty == 0){
          		this.removeVoucherOrder(params)
          	}else{
            	this.setVoucherOrder(params)
          	}
          }
			},
			calPromotionPrice(price){
				if(price.promotion_amount == 0){
          return 0
        }else{
          return price.tax_service_calculation_type == 'INCLUDE' ? price.price_sell_base : price.price_sell
        }
			},
			calcIsDecreasePromo(price){
				if(price.promotion_amount == 0){
          return false
        }else{
          return price.promotion_type == 'INCREASE' ? false : true
        }
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/hotel/upselling/VoucherItemCart.vue